import * as yup from 'yup';
import { format } from 'date-fns';
import { validateDateOfBirth } from '../utils';
import { maxBirthDate, minBirthDate } from './addSepa.schema';

export const DoBModal = (user: any) => ({
  dateOfBirth: user?.dateOfBirth
    ? format(new Date(user?.dateOfBirth), 'yyyy-MM-dd')
    : '',
});

export const DoBSchema = (localize: any): any =>
  yup.object({
    dateOfBirth: yup
      .string()
      .required(localize('validation.required'))
      .test('is-date-in-range', localize('input.error.invalid'), (value) => {
        return validateDateOfBirth(value, minBirthDate, maxBirthDate);
      }),
  });
